import React from 'react';
import { number, string, node } from 'prop-types';

import { ImgWrap, BGWrap } from './styled';

const BackgroundComponent = ({ className = "", width, height, imgUrl, children, isNaverForm = false, formUrl = "", coordsList = [] }) => {
  if (isNaverForm) {
    const isArea = coordsList.length > 0;

    return (
      <ImgWrap width={width} height={height}>
        <img src={imgUrl} useMap="#map" />
        {isArea && (
          <map name="map">
            {coordsList.map(coords => <area id="link-btn" target="_blank" alt="" title="" href={formUrl} coords={coords} shape="rect" />)}
          </map>
        )}
      </ImgWrap>
    );
  }

  return (
    <BGWrap className={className} width={width} height={height} imgUrl={imgUrl}>
      {children}
    </BGWrap>
  );
};

BackgroundComponent.propTypes = {
  width: number.isRequired,
  height: number.isRequired,
  imgUrl: string.isRequired,
  children: node,
};

export default BackgroundComponent;
